import React, { useState } from 'react';
import { 
  SiMongodb, 
  SiExpress, 
  SiNodedotjs, 
  SiNestjs,
  SiGraphql,
  SiTypescript,
  SiReact,
  SiNextdotjs,
  SiSocketdotio,
  SiPostgresql,
  SiMysql
} from 'react-icons/si';

interface Skill {
  name: string;
  icon: React.ReactNode;
  color: string;
}

const Skills: React.FC = () => {
  const [hoveredSkill, setHoveredSkill] = useState<number | null>(null);

  const skills: Skill[] = [
    { name: 'MongoDB', icon: <SiMongodb />, color: 'text-green-500' },
    { name: 'Express.js', icon: <SiExpress />, color: 'text-gray-300' },
    { name: 'Node.js', icon: <SiNodedotjs />, color: 'text-green-600' },
    { name: 'NestJS', icon: <SiNestjs />, color: 'text-red-600' },
    { name: 'GraphQL', icon: <SiGraphql />, color: 'text-pink-600' },
    { name: 'TypeScript', icon: <SiTypescript />, color: 'text-blue-600' },
    { name: 'React', icon: <SiReact />, color: 'text-blue-400' },
    { name: 'Next.js', icon: <SiNextdotjs />, color: 'text-white' },
    { name: 'Socket.io', icon: <SiSocketdotio />, color: 'text-white' },
    { name: 'PostgreSQL', icon: <SiPostgresql />, color: 'text-blue-700' },
    { name: 'MySQL', icon: <SiMysql />, color: 'text-blue-500' }
  ];

  return (
    <section id="skills" className="relative py-20 bg-[#0a0a0f] border-t border-white/5">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-aos="fade-up" className="mb-12">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-light text-white mb-3">
            Technologies
          </h2>
          <p className="text-gray-400 text-lg">Tools and frameworks I work with</p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-4 md:gap-6">
          {skills.map((skill, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 30}
              onMouseEnter={() => setHoveredSkill(index)}
              onMouseLeave={() => setHoveredSkill(null)}
              className="group relative flex flex-col items-center justify-center p-6 rounded-lg bg-white/5 border border-white/10 hover:border-white/20 hover:bg-white/10 transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className={`relative z-10 text-4xl md:text-5xl mb-3 transition-all duration-300 ${
                skill.color
              } ${hoveredSkill === index ? 'scale-110' : ''}`}>
                {skill.icon}
              </div>
              
              {/* Name */}
              <span className={`relative z-10 text-gray-400 text-xs md:text-sm text-center font-medium transition-colors duration-300 ${
                hoveredSkill === index ? 'text-white' : ''
              }`}>
                {skill.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
